var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 0.783382H1.79943C1.12705 0.783382 0.582031 1.32845 0.582031 2.00078V15.3959H19.4243V2.00481C19.4243 1.33122 18.8762 0.783203 18.2069 0.783203V0.783382ZM17.3326 13.3043H2.67365V2.87482H17.3326V13.3043Z",
    fill: "#092C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2324C0.187455 17.3577 1.15987 18.215 2.33882 18.215H17.667C18.7796 18.215 19.7996 17.443 20 16.2324H0Z",
    fill: "#092C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8607 9.53061V12.5423C12.8607 12.6694 12.7619 12.7682 12.6348 12.7682H10.7044C10.5773 12.7682 10.4785 12.6694 10.4785 12.5423V9.53061C10.4785 9.40349 10.5773 9.30469 10.7044 9.30469H12.6348C12.7619 9.30469 12.8607 9.40349 12.8607 9.53061Z",
    fill: "#092C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19469 10.2613V12.5447C6.19469 12.6718 6.09589 12.7706 5.96876 12.7706H4.03843C3.91602 12.7706 3.81722 12.6765 3.8125 12.5539V12.5445V10.2611C3.8125 10.134 3.9113 10.0352 4.03843 10.0352H5.96876H5.9782C6.10043 10.0399 6.19468 10.1389 6.19468 10.2613L6.19469 10.2613Z",
    fill: "#092C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52672 8.26499V12.5424C9.52672 12.6695 9.42792 12.7683 9.30079 12.7683H7.37046C7.24333 12.7683 7.14453 12.6695 7.14453 12.5424V8.26499C7.14453 8.13786 7.24333 8.03906 7.37046 8.03906H9.30079C9.42791 8.03906 9.52672 8.13786 9.52672 8.26499Z",
    fill: "#092C4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1947 8.37632V12.5428C16.1947 12.6699 16.0959 12.7687 15.9688 12.7687H14.0384C13.9113 12.7687 13.8125 12.6699 13.8125 12.5428V8.37632C13.8125 8.24919 13.9113 8.15039 14.0384 8.15039H15.9688C16.0959 8.15039 16.1947 8.24919 16.1947 8.37632Z",
    fill: "#092C4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15462 8.17509C4.04515 8.04062 4.06509 7.8432 4.19938 7.73373L7.3181 5.19016C7.78796 4.80615 8.42936 4.71067 8.99068 4.94185L11.3636 5.91603C11.6637 6.03896 12.0081 6.01221 12.2855 5.84364L15.4438 3.92432C15.5919 3.83479 15.7849 3.88165 15.875 4.02959C15.9648 4.1777 15.9178 4.37075 15.7697 4.46081L12.6114 6.37995C12.1641 6.65169 11.6084 6.69506 11.1251 6.49658L8.75235 5.5224C8.40384 5.37936 8.00638 5.43864 7.71469 5.67645L4.59597 8.22003C4.4622 8.32914 4.26407 8.30956 4.15461 8.17509L4.15462 8.17509Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.da388a5e0d73ec1f9cfc3cfbcceda137.svg";
export { ForwardRef as ReactComponent };